import { render, staticRenderFns } from "./infoDeta.vue?vue&type=template&id=73836e8f&scoped=true&"
import script from "./infoDeta.vue?vue&type=script&lang=js&"
export * from "./infoDeta.vue?vue&type=script&lang=js&"
import style0 from "./infoDeta.vue?vue&type=style&index=0&id=73836e8f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73836e8f",
  null
  
)

export default component.exports